import gql from 'graphql-tag';

const SignUpMutation = gql`
  mutation SignUp(
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $shop: String!
  ) {
    signUp(
      input: {
        email: $email
        password: $password
        firstName: $firstName
        lastName: $lastName
        shop: $shop
      }
    ) {
      session {
        id
        email
        tenant {
          isShopifyLead
          name
          onboardingChecklist {
            showOnboardingModal
          }
          siteBuilderThemeId
          sitePlan
          subdomain
        }
      }
      result {
        success
        status
        errors {
          code
          title
          message
        }
      }
    }
  }
`;

export default SignUpMutation;
